import { render, staticRenderFns } from "./booking-row.vue?vue&type=template&id=90134aec&scoped=true&"
import script from "./booking-row.vue?vue&type=script&lang=js&"
export * from "./booking-row.vue?vue&type=script&lang=js&"
import style0 from "./booking-row.vue?vue&type=style&index=0&id=90134aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90134aec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
